export default __webpack_public_path__ + "static/media/property_223.35f9181a.png";